exports.key = 'shcz190329'

// 设置全局变量
const varsPlugin = {
  install(Vue) {
    // 活动key
    Vue.prototype.$key = exports.key
    // 环境变量
    Vue.prototype.$env = process.env.VUE_APP_ENV
    // 不同环境的接口
    const baseURL = {}
    if (process.env.VUE_APP_ENV === 'prod') {
      baseURL.cat = 'https://cat.pangku.com'
      baseURL.api = 'https://api.pangku.com'
      baseURL.merchant = 'https://merchant.pangku.com'
    } else {
      baseURL.cat = 'https://at.pangku.com'
      baseURL.api = 'https://tapi.pangku.com'
      baseURL.merchant = 'https://prem.pangku.com'
    }
    Vue.prototype.$baseURL = baseURL
  }
}

exports.vars = varsPlugin

// 分享文案，图片上传到七牛https://pangku.com/upload/qiniu
// link填cat.pangku.com，自动判断环境
exports.shareData = {
  title: '上海国际车展邀你翻牌赢888元现金红包!',
  desc: '百万现金红包+海量购车钜惠等你来拿~',
  link: 'https://cat.pangku.com/dist/shcz190329/index.html',
  imgUrl: 'https://pub.pangku.com/201903/5d0b774b75db90fa5b30501c6b9d83e8.jpg'
}

// 重新运行才能生效
// 地址相对vue.config.js
exports.pages = {
  index: {
    template: './src/shcz190329/base/template.html',
    title: '上海国际车展',
    entry: './src/shcz190329/index/index.js',
    filename: 'index.html',
    chunks: ['chunk-vendors', 'chunk-common', 'index']
  },
  game: {
    template: './src/shcz190329/base/template.html',
    title: '上海国际车展',
    entry: './src/shcz190329/game/game.js',
    filename: 'game.html',
    chunks: ['chunk-vendors', 'chunk-common', 'game']
  },
  prize: {
    template: './src/shcz190329/base/template.html',
    title: '上海国际车展',
    entry: './src/shcz190329/prize/prize.js',
    filename: 'prize.html',
    chunks: ['chunk-vendors', 'chunk-common', 'prize']
  },
  share: {
    template: './src/shcz190329/base/template.html',
    title: '上海国际车展',
    entry: './src/shcz190329/share/share.js',
    filename: 'share.html',
    chunks: ['chunk-vendors', 'chunk-common', 'share']
  },
  rule: {
    template: './src/shcz190329/base/template.html',
    title: '上海国际车展',
    entry: './src/shcz190329/rule/rule.js',
    filename: 'rule.html',
    chunks: ['chunk-vendors', 'chunk-common', 'rule']
  }
}

// 前端、后端和设计
exports.author = {
  frontend: 'dengweiyang',
  backend: 'yaoxinzhen',
  designer: 'lujie'
}
